import type { ReactNode } from "react";
import { Link } from "react-router";
import { ThemeButton } from "@/components/ThemeButton";
import { Copy, type CopyKey, type CopyParams } from "@/copy/copy";

/** `?next=` only ever points inside the app: a path starting with one slash. */
export function safeNext(raw: string | null | undefined, fallback: string): string {
  if (!raw) return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return fallback;
  return raw;
}

/** The auth screens' frame: brand, theme toggle, and one centred card in the prototype's style. */
export function AuthLayout({
  title,
  sub,
  params,
  children,
  testId,
}: {
  title: CopyKey;
  sub?: CopyKey;
  params?: CopyParams;
  children: ReactNode;
  testId: string;
}) {
  return (
    <div className="wp-auth" data-testid={testId}>
      <div className="wp-auth-top">
        <Link to="/" className="wp-auth-brand" aria-label="WealthyPlanet home">
          <span className="mk" />
          <b>Wealthy</b>
          <span>Planet</span>
        </Link>
        <ThemeButton />
      </div>
      <main className="wp-auth-card">
        <Copy k={title} as="h1" />
        {sub && <Copy k={sub} params={params} as="p" className="sub" />}
        {children}
      </main>
    </div>
  );
}

export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <span className="err" role="alert">
      {message}
    </span>
  );
}
